<style>
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.total-rows {
  padding: 10px;
  font-weight: bold;
}
</style>
<template>
    <div class="card">
      <div class="card-header pb-0 d-flex">
        <h6>Vehicle table</h6>
        <input
          type="text"
          v-model="searchQuery"
          placeholder="Search..."
          class="form-control mb-3 ms-auto"
          style="max-width: 250px; "
        />
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0" style="width:100%">
            <thead>
              <tr>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Vehicle No
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Type
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Details
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Created Date
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(vehicle,index) in paginatedVehicle" :key="index">
                <td>
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{ (currentPage-1)*20 + index +1 }} - {{ vehicle.vehicleno }}</h6>
                        <span class="text-xs font-weight-bold" >
                          Status: {{ vehicle.isexpired }}
                          </span>
                    </div>
                  </div>
                </td>
                <td class="align-middle" style="max-width: 20%; width: 20%; white-space: normal; word-wrap: break-word;">
                  <span class="text-xs font-weight-bold">
                    Type: {{ vehicle.type }}<br />
                    Remarks: {{ vehicle.remark }}
                    </span>
                </td>
                <td class="align-middle">
                  <span class="text-xs font-weight-bold" >
                    Puspakom:  {{ vehicle.puspakom }}<br />
                    Insurance: {{ vehicle.insurance }}<br />
                    RoadTax:  {{ vehicle.roadtax }}
                    </span>
                </td>
                <td class="align-middle">
                  <span class="text-xs font-weight-bold" >
                    Created: {{ vehicle.created_at }}<br />
                    Updated: {{ vehicle.updated_at }}
                    </span>
                </td>
                <td class="align-middle">
                  <RouterLink :to="{path : '/editVehicle/'+ vehicle.id}"
                    href="javascript:;"
                    class="text-secondary font-weight-bold text-xs"
                    data-toggle="tooltip"
                    data-original-title="Edit Vehivle"
                    >Edit
                  </RouterLink>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- Pagination Controls -->
          <hr />
          <div class="pagination-container">
            <div>
              <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-info">Previous</button>
              <span class="form-control-label" style="padding:10px"> Page {{ currentPage }} of {{ totalPages }} </span>
              <button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-info">Next</button>
            </div>
            
            <span class="form-control-label total-rows">Total {{ totalRows }} entries </span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
import axios from 'axios';

export default {
  name:'VehicleSelect',
  data(){
    return {
        totalRows:0,
        currentPage: 0,
        perPage: 20,
        searchQuery:'',
        vehicle: []
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.vehicle.length / this.perPage);
    },
    paginatedVehicle() {
      const start = (this.currentPage - 1) * this.perPage;
      let query = this.searchQuery.toLowerCase();

      // Filter customers by checking all properties in each row
      let filtered = this.vehicle.filter(customer => {
        return Object.values(customer).some(value =>
          String(value).toLowerCase().includes(query)
        );
      });
      return filtered.slice(start, start + this.perPage);
    }
  },
  mounted(){
    this.getVehicleList();
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    getVehicleList(){
        // var mythis = this;
        axios.get('vehicle/listAllVehicle')
            .then(res => {
                this.currentPage = 1;
                this.totalRows = res.data.vehicle.length;
                this.vehicle = res.data.vehicle;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Name, Company, Contact, State and Address is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
  },
}
</script>